import { createSlice } from '@reduxjs/toolkit';

const csrfSlice = createSlice({
  name: 'csrf',
  initialState: {
    csrftoken: null,
  },
  reducers: {
    setCsrfToken: (state, action) => {
        // console.log('setCsrfToken called with:', action.payload);
      state.csrftoken = action.payload;
    },
  },
});

export const { setCsrfToken } = csrfSlice.actions;
export const selectCsrfToken = (state) => state.csrf.csrftoken;
export default csrfSlice.reducer;
